export default function handleNotFound(str) {
    throw new Error(`Fallback translation not found: ${str}`);
}
//# sourceMappingURL=handle-not-found.js.map